import React from "react";
import "../styles/Spinner.css"; // Import CSS for styling

const Spinner = () => {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default Spinner;